import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Logo.module.css';

export default function () {
    return (<div className={styles.logo}>
        <Link to="/"><img src='/images/ukfuelsonline_horizontal.svg' alt='UK Fuels Site Portal' /></Link>
    </div>);
}